/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ActivateBarcodes({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ActivateBarcodes.Outline {...props} />
  ) : (
    <ActivateBarcodes.Solid {...props} />
  );
}

ActivateBarcodes.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M20.97 8.84V7.33C20.97 5.27 19.3 3.6 17.24 3.6L16.04 3.6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M3 16.25V17.76C3 19.82 4.67 21.49 6.73 21.49L7.94 21.49"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M3 8.84V7.33C3 5.27 4.67 3.6 6.73 3.6H7.97"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M20.97 16.25V17.76C20.97 19.82 19.3 21.49 17.24 21.49L16 21.49"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <rect
          x="6.5"
          y="6.5"
          width="2"
          height="12"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="10"
          y="6.5"
          width="1"
          height="12"
          rx="0.25"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="17"
          y="6.5"
          width="1"
          height="12"
          rx="0.25"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="13"
          y="6.5"
          width="2"
          height="12"
          rx="0.5"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ActivateBarcodes.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M20.97 8.84V7.33C20.97 5.27 19.3 3.6 17.24 3.6L16.04 3.6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 16.25V17.76C3 19.82 4.67 21.49 6.73 21.49L7.94 21.49"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 8.84V7.33C3 5.27 4.67 3.6 6.73 3.6H7.97"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.97 16.25V17.76C20.97 19.82 19.3 21.49 17.24 21.49L16 21.49"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="6.5"
          y="6.5"
          width="2"
          height="12"
          rx="0.5"
          fill="currentColor"
        />
        <rect
          x="10"
          y="6.5"
          width="1"
          height="12"
          rx="0.25"
          fill="currentColor"
        />
        <rect
          x="17"
          y="6.5"
          width="1"
          height="12"
          rx="0.25"
          fill="currentColor"
        />
        <rect
          x="13"
          y="6.5"
          width="2"
          height="12"
          rx="0.5"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
